import { autoinject } from 'aurelia-dependency-injection';
import { bindable } from 'aurelia-framework';
import { ContractLine } from '../../services/customer-info-store';
import { DialogService } from 'aurelia-dialog';

@autoinject
export class LicenseStatusTile {

    @bindable line: ContractLine;
    @bindable organizationid: string = "";

    constructor(private dialogService: DialogService) {
    }

}


// WEBPACK FOOTER //
// ./ClientApp/app/components/licensing-overview/license-status-tile.ts